import { FC, useState } from 'react'
import i18n from 'translations/i18n'
import { PaymentConfigurationType } from 'redux/setting/payrollManagement/paymentMethods/reducer'
import { Modal, Flex, Button, Select } from '@jisr-hr/design-system'
import { Typography } from '@jisr-hr/ds'
import { shallowEqual } from 'react-redux'
import { useSelector } from 'utils/hooks'
import mainStyles from 'containers/authorised/setting/v2/payroll/PaymentProcess/payment.module.css'
import { usePaymentMethod } from '../../components/usePaymentMethods'

const AddNewPaymentConfigModal: FC = () => {
  const paymentCtx = usePaymentMethod()
  const { addNewConfigOpen } = paymentCtx

  const unlinked_list = useSelector((s) => s.paymentMethods.pending_payment_methods, shallowEqual)
  const fetching = useSelector((s) => s.paymentMethods.fetchingShowMethod)
  const [selectedCR, selectCR] = useState<PaymentConfigurationType | null>(null)

  const handleClose = (): void => {
    paymentCtx.setAddNewConfigOpen(false)
    selectCR(null)
  }

  const commercial_registrations_options = unlinked_list.reduce(
    (CRs: PaymentConfigurationType[], currentCR): PaymentConfigurationType[] => {
      CRs.push({
        ...currentCR,
        name: `${currentCR.name} - ${currentCR.registration_number}`,
      })
      return CRs
    },
    [],
  )
  return (
    <Modal
      isOpen={addNewConfigOpen}
      onClose={handleClose}
      variant="centerDialog"
      width={500}
      modalContentStyle={{ overflow: 'initial' }}
      modalFooterStyle={{ padding: '8px 24px 24px', height: 'auto', border: 'unset' }}
      modalHeaderStyle={{ background: '#fff', padding: '24px 16px 16px', minHeight: 'auto' }}
      modalPaperClassName={mainStyles.modal__overflow}
      header={
        <Typography
          variant="subtitle-1"
          style={{ lineHeight: '20px', color: 'var(--color-base-colors/grey/1000' }}
          text={i18n.t('commercial_registration')}
        />
      }
      footer={
        <Flex
          itemsCenter
          justifyEnd
          style={{ gap: 8 }}
        >
          <Button
            label={i18n.t('cancel')}
            size="medium"
            onClick={handleClose}
            variant="secondary"
          />
          <Button
            disabled={fetching || !selectedCR}
            label={i18n.t('start_setup_payment_method')}
            onClick={(): Promise<void> => paymentCtx.handleSetupMethodOpen(selectedCR)}
            size="medium"
          />
        </Flex>
      }
    >
      <div style={{ padding: 24 }}>
        <Typography
          variant="interface/default/sm"
          style={{ marginBottom: 32 }}
          text={i18n.t('choose_the_commercial_registration')}
        />
        <Select
          label={i18n.t('your_commercial_registration')}
          onChange={(value: PaymentConfigurationType): void => selectCR(value)}
          value={selectedCR}
          placeholder={i18n.t('commercial_registration')}
          getOptionValue={(option: PaymentConfigurationType): number => option.id}
          getOptionLabel={(option: PaymentConfigurationType): string => option.name}
          options={commercial_registrations_options}
        />
      </div>
    </Modal>
  )
}

export default AddNewPaymentConfigModal
